import {
    GRID_DATA_TABLE_URL_SET,
} from '../actions/gridDataTable';

const initialState = {
    url: '',
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GRID_DATA_TABLE_URL_SET:
            return Object.assign({}, state, {
                url: action.url
            });

        default:
            return state;
    }
}

export function createReducer(stateKey) {
    return (state = initialState, action) => {
        if (!action.stateKey || action.stateKey !== stateKey) {
            return state;
        }

        return reducer(state, action);
    };
}



// WEBPACK FOOTER //
// ./src/js/reducers/gridDataTable.js